exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-c500fab4] .el-card__body{height:100%}.detail-height[data-v-c500fab4]{height:calc(100% - 52px)}.form-height[data-v-c500fab4]{height:calc(100% - 25px)}", ""]);

// exports
